import { Component, OnInit } from '@angular/core';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';
import { MenuRestaurantService } from './menu-restaurant.service';

@Component({
  selector: 'app-menu-restaurant',
  templateUrl: './menu-restaurant.component.html',
  styleUrls: ['./menu-restaurant.component.scss'],
})
export class MenuRestaurantComponent implements OnInit {
  exist: boolean = true;
  selectedIndexResto;
  selectedResto = null;

  dateDeb = new Date('01-01-2020');
  dateFin = new Date();
  paramListTarifs =
    this.dateService.setFormatDateRechercheServer(this.dateDeb) +
    ',' +
    this.dateService.setFormatDateRechercheServer(this.dateFin) +
    ',';

  Tarif_Code;

  COLUMNS_SCHEMA = [
    {
      key: 'Tarif_Code',
      type: 'number',
      label: 'Code tarif',
    },
    {
      key: 'Tiers_code',
      type: 'text',
      label: 'Code tiers',
    },
    {
      key: 'Valide',
      type: 'checkbox',
      label: 'isValide?',
    },
    {
      key: 'Type_Tarif',
      type: 'number',
      label: 'Type_Tarif',
    },

    {
      key: 'IND_COLL',
      type: 'select',
      label: 'IND_COLL',
      options: [
        { label: 'IND', value: 'IND' },
        { label: 'COL', value: 'COL' },
      ],
    },
    {
      key: 'Tarif',
      type: 'number',
      label: 'Tarif',
    },
    {
      key: 'Observation',
      type: 'textarea',
      label: 'Observation',
    },
    {
      key: 'Date_Deb',
      type: 'date',
      label: 'Date_Deb',
    },
    {
      key: 'Date_Fin',
      type: 'date',
      label: 'Date_Fin',
    },
    {
      key: 'Groupe_Min',
      type: 'number',
      label: 'Groupe_Min',
    },
    {
      key: 'Groupe_Max',
      type: 'number',
      label: 'Groupe_Max',
    },
  ];
  constructor(
    public generalService: GeneralService,
    public menuRestoService: MenuRestaurantService,
    private dateService: DateService
  ) {}

  ngOnInit(): void {
    this.menuRestoService.getRestaurants();
  }

  onClickOnResto(index, resto) {
    this.selectedIndexResto = index;
    this.selectedResto = resto;

    this.paramListTarifs =
      this.dateService.setFormatDateRechercheServer(this.dateDeb) +
      ',' +
      this.dateService.setFormatDateRechercheServer(this.dateFin) +
      ',' +
      resto.Tiers_code;

    this.menuRestoService.DS_menuRestaurant.Menu_RestaurantD[0].Tiers_Code =
      resto.Tiers_code;
    this.menuRestoService.getMenuByRestaurant(resto);
  }
  getInitials(resto): string {
    const nameParts = resto.split(' ');
    const initials = nameParts.map((part) => part.charAt(0).toUpperCase());
    return initials.join('');
  }
}
